<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    size="50%"
    :before-close="cancel"
    direction="rtl"
  >
    <div class="drawer-container">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        label-position="left"
        :rules="rules"
      >
        <div>
          <div class="leftTag">基本信息</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供应商编号" prop="cVenCode">
              <el-input
                v-model="form.cVenCode"
                disabled
                placeholder="自动生成"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称" prop="cVenName">
              <el-input v-model="form.cVenName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="cVenPerson">
              <el-input v-model="form.cVenPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="cVenPhone">
              <el-input v-model="form.cVenPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地址" prop="Address">
              <el-input v-model="form.Address" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <button @click="getCheckedNodes">获取选中的节点</button>-->
        <!--        <div>选中的节点：{{ checkedNodes }}</div>-->
        <!-- <el-form-item label="设备分类">
         
           <el-tree
             :data="ecList"
             show-checkbox
             node-key="id"
             :default-expand-all="true"
             :props="defaultProps"
             ref="tree"
             @check-change="handleCheckChange"
           >
           </el-tree>
         </el-form-item> -->
        <el-form-item label="备注">
          <el-input
            v-model="form.Remarks"
            type="textarea"
            :autosize="{ minRows: 4 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button size="mini" @click="confirm" type="primary">保存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/utils/validate/validate.js'
export default {
  data() {
    return {
      visible: false,
      rules: {
        cVenName: [{ required: true, message: '请输入供应商名称' }],
        cVenPerson: [{ required: true, message: '请输入联系人' }],

        cVenPhone: [
          {
            validator: validate.validatePhone,
            trigger: 'blur',
            required: true,
            message: '请输入正确的手机号',
          },
        ],
      },
      ecList: [],
      form: {},
      title: '',
      defaultKeys: [0], // 指定哪些节点的子节点默认展开
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      checkedNodes: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    open(form, title) {
      this.title = title
      this.visible = true
      this.form = JSON.parse(JSON.stringify(form))
      this.ecList = []
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.$http
          .post('/Base_BasicData/Base_Supplier/SaveData', this.form)
          .then((res) => {
            if (res.Success) {
              this.$notify.success('操作成功')
              this.$emit('comfirm', true)
              this.visible = false
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
      // console.log(this.$refs.tree.getCheckedNodes());
      console.log(this.$refs.tree.getCheckedKeys())
      this.form.EquipmentClassificationIds = JSON.stringify(
        this.$refs.tree.getCheckedKeys()
      )
      console.log(this.form)
    },
    // getCheckedNodes() {
    //   const nodes = this.$refs.tree.getCheckedNodes(); // 获取所有选中的节点数据
    //   this.checkedNodes = nodes.map(node => node.id); // 只获取节点的 ID 并存储在 checkedNodes 中
    // },
    cancel() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 100)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 0 20px;
}

.drawer-container {
  padding: 20px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 60px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
}

.leftTag {
  margin: 20px 0;
  // margin-left: -20px;
  width: 98px;
  padding: 10px;
  padding-right: 30px;
  background: #409eff;
  border-radius: 0 100px 100px 0;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}
::v-deep .el-tree-node__children .el-tree-node {
  float: left;
}
</style>
